var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hidden",
    clipPath: "url(#clip0_1299_1105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99995 2.63596C9.33752 2.63011 10.6494 3.00125 11.7841 3.7065C12.9188 4.41174 13.83 5.4223 14.4122 6.62139C13.991 7.48686 13.3941 8.25591 12.6591 8.87996L13.7034 9.90102C14.728 9.00272 15.5219 7.87338 16.0189 6.60728C15.2126 4.57974 13.6614 2.93386 11.6805 2.00397C9.69963 1.07408 7.43754 0.929926 5.35376 1.60078L6.554 2.79594C7.02945 2.69496 7.51383 2.64137 7.99995 2.63596Z",
    fill: "#F0C52F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.22032 3.46416L8.7277 4.96046L9.67277 5.90153L11.1754 7.40254C11.3032 6.92194 11.3175 6.4184 11.2171 5.9314C11.1167 5.4444 10.9043 4.98719 10.5967 4.59561C10.289 4.20404 9.8945 3.88876 9.44397 3.67449C8.99345 3.46022 8.49921 3.3528 8 3.36064C7.73673 3.36173 7.47468 3.39652 7.22032 3.46416ZM0.732428 1.09737L2.68399 3.03597C1.4829 3.97011 0.555921 5.20843 0 6.62145C0.833484 8.73414 2.47562 10.4306 4.56519 11.3378C6.65475 12.2449 9.02061 12.2883 11.1424 11.4585L13.6279 13.9336L14.6486 12.9125L1.75783 0.0668945L0.732428 1.09737ZM3.71412 4.06644L4.98996 5.33218C4.81318 5.73247 4.72301 6.16534 4.72534 6.60263C4.72396 7.13817 4.85602 7.66569 5.1097 8.13792C5.36338 8.61015 5.73076 9.01233 6.1789 9.30842C6.62704 9.60452 7.14195 9.78529 7.67749 9.83452C8.21304 9.88375 8.75248 9.79992 9.24749 9.59052L9.27584 9.61876L9.98937 10.3293C9.33833 10.5087 8.66607 10.6005 7.99055 10.6022C6.655 10.6042 5.34582 10.232 4.21271 9.52805C3.0796 8.8241 2.16829 7.81684 1.58299 6.62145C2.08278 5.61544 2.81273 4.7403 3.71412 4.06644Z",
    fill: "#F0C52F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1299_1105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 13.8667,
    fill: "white",
    transform: "translate(0 0.0668945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.443b1b6caae62cb9bf04e658b8c3976d.svg";
export { ForwardRef as ReactComponent };